import * as bootstrap from "bootstrap";
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import {validateMail, resetForm} from "./functions.js";

require('./bootstrap');

require('blueimp-file-upload');

window.swal = require('sweetalert2');

window.Vue = require('vue');


/**
 * Import components
 *
 */


window.translations = {
    'please_select' : { 'de' : 'Bitte auswählen', 'en' : 'Please select', nl : 'Please select' },
    'no_car' : { 'de' : 'wird gebracht/Taxi oder ÖPNV - kein VPS', 'en' : 'is brought/taxi or public transport - no VPS', 'nl' : 'is brought/taxi or public transport - no VPS'  },
    'vps' : { 'de' : 'eigener PKW - VPS gewünscht', 'en' : 'own car - VPS desired', 'nl' : 'own car - VPS desired' },
    'crv' : { 'de' : 'Rückgabe eines SIXT Mietwagens', 'en' : 'Return of a SIXT rental car', 'nl' : 'Return of a SIXT rental car' },
    'uid_lookup': { 'de' : 'UID für Kunde nachschlagen', 'en' : 'UID lookup', 'nl' : 'UID lookup'},
    'uid': { 'de' : 'UID', 'en' : 'UID', 'nl' : 'UID'},
    'add_services': { 'de' : 'Kostenpflichtige Services für ', 'en' : 'Chargeable services for ', 'nl' : 'Chargeable services for '},
    'ok': { 'de' : 'Ok', 'en' : 'Ok', 'nl' : 'Ok'},
    'cancel': { 'de' : 'Abbrechen', 'en' : 'Cancel', 'nl' : 'Cancel'},
    'proceed': { 'de' : 'weiter', 'en' : 'further...', 'nl' : 'further...'},
    'open_booking' : { 'de' : 'Es existiert mindestens eine offene Buchung für diesen Kunden. Bitte schließen Sie diese Buchung zuerst ab.',
                       'en' : 'There is at least one open booking for this customer. Please close this booking first.',
                       'nl' : 'There is at least one open booking for this customer. Please close this booking first.'},
    'save_error_title' : { 'de' : 'Fehler beim Speichern', 'en' : 'Error while saving', 'nl' : 'Error while saving'},
    'save_error_text' : { 'de' : 'Der Auftrag konnte nicht gespeichert werden', 'en' : 'The order could not be saved', 'nl' : 'The order could not be saved'},
    'save_success_title' : { 'de' : 'Auftrag gespeichert', 'en' : 'Order saved', 'nl' : 'Order saved'},
    'save_success_text' : { 'de' : 'Der Auftrag wurde gespeichert', 'en' : 'The order has been saved'},
    'order_error_title' : { 'de' : 'Fehler im Auftrag', 'en' : 'Error in the order', 'nl' : 'Error in the order'},
    'order_error_text' : { 'de' : 'Der Auftrag wurde nicht gespeichert. Bitte korrigieren Sie die fehlerhaften Eingaben.', 'en' : 'The order was not saved. Please correct the incorrect entries.', 'nl' : 'The order was not saved. Please correct the incorrect entries.'},
    'storno1_title' : { 'de' : 'Stornierungsfrist', 'en' : 'Cancellation deadline'},
    'storno1_text' : { 'de' : 'Die Stornierungsfrist ist bereits abgelaufen. Die Stornierung ist nicht mehr kostenfrei möglich.', 'en' : 'The cancellation period has already expired. Cancellation is no longer possible free of charge.', 'nl' : 'The cancellation period has already expired. Cancellation is no longer possible free of charge.'},
    'storno' : { 'de' : 'Stornieren', 'en' : 'Cancel order', 'nl' : 'Cancel order'},
    'storno_title' : { 'de' : 'Stornierung', 'en' : 'Cancel order', 'nl' : 'Cancel order'},
    'storno_text' : { 'de' : 'Diesen Auftrag wirklich stornieren? Der Vorgang kann nicht rückgängig gemacht werden.', 'en' : 'Really cancel this order? The operation cannot be cancelled.', 'nl' : 'Really cancel this order? The operation cannot be cancelled.'},
    'storno_success_title' : { 'de' : 'Auftrag storniert', 'en' : 'Order canceled', 'nl' : 'Order canceled'},
    'storno_success_text' : { 'de' : 'Der Auftrag wurde storniert', 'en' : 'The order has been canceled.', 'nl' : 'The order has been canceled.'},
    'booking_created_info' : { 'de' : ' Buchung wurde erzeugt. Bitte unbedingt die Buchung öffnen und vervollständigen!', 'en' : ' Booking was created. Please be sure to open and complete the booking!', 'nl' : ' Booking was created. Please be sure to open and complete the booking!'},
    'booking_created_next_vps' : { 'de' : 'zugehörige VPS Buchung öffnen', 'en' : 'open associated VPS order', 'nl' : 'open associated VPS order'},
    'booking_created_next_crv' : { 'de' : 'zugehörigen CRV Auftrag öffnen', 'en' : 'open associated CRV order', 'nl' : 'open associated CRV order'},
    'send_invalid_title' : { 'de' : 'Bitte folgende Fehler korrigieren:', 'en' : 'Please correct the following errors:', 'nl' : 'Please correct the following errors:'},
    'send_email_invalid_text' : { 'de' : 'Bitte geben Sie eine gültige E-Mail Adresse an.', 'en' : 'Please enter a valid e-mail address.', 'nl' : 'Please enter a valid e-mail address.'},
    'please_enter_name' : { 'de' : 'Name bitte eingeben.', 'en' : 'Please enter name.', 'nl' : 'Please enter name.'},
    'please_enter_bookingcode' : { 'de' : 'Buchungscode bitte eingeben.', 'en' : 'Please enter booking code.', 'nl' : 'Please enter booking code.'},
    'psp_info_options' : {
        'de' : ['Touristische Buchung', 'Hotelbuchung', 'Internet - Light Tarif', 'Low Cost Carrier', 'Amex Online Buchung', 'Hoher Jahresumsatz', 'Reklamation', 'Gewohnheitsrecht', 'ich habe mit Amex bezahlt', 'sonstiges'],
        'en' : ['Tourist booking', 'Hotel booking', 'Internet - Light rate', 'Low cost carrier', 'Amex online booking', 'High annual turnover', 'Complaint', 'Customary law', 'I paid with Amex', 'other'],
        'nl' : ['Tourist booking', 'Hotel booking', 'Internet - Light rate', 'Low cost carrier', 'Amex online booking', 'High annual turnover', 'Complaint', 'Customary law', 'I paid with Amex', 'other']
    },
    'important_notice' : { 'de' : 'Wichtiger Hinweis', 'en' : 'Important notice', 'nl' : 'Important notice'},
    'prebookingtime_too_short' : { 'de' : 'Die Vorausbuchungsfrist ist unterschritten', 'en' : 'The advance booking deadline has been missed', 'nl' : 'The advance booking deadline has been missed'},
    'prebookingtime' : { 'de' : 'Vorausbuchungsfrist', 'en' : 'Advance booking deadline', 'nl' : 'Advance booking deadline'},
    'remark' : { 'de' : 'Hinweis', 'en' : 'Remark', 'nl' : 'Remark'},
    'service' : { 'de' : 'Service', 'en' : 'Service', 'nl' : 'Service'},
    'description' : { 'de' : 'Beschreibung', 'en' : 'Description', 'nl' : 'Description'},
    'price' : { 'de' : 'Preis', 'en' : 'Price', 'nl' : 'Price'},
    'prices_title' : { 'de': 'Preisinformation', 'en':'Price info', 'nl' : 'Price info' },

}

/**
 * Define Vue Instance per page
 *
 */

window.pages = {
    vipservice_index: require('./pages/vipservice/index.js').default,
    vipservice_booking: require('./pages/vipservice/booking.js').default,
    vipservice_send: require('./pages/vipservice/send.js').default,
    vpservice_index: require('./pages/vpservice/index.js').default,
    vpservice_booking: require('./pages/vpservice/booking.js').default,
    crvservice_index: require('./pages/crvservice/index.js').default,
    crvservice_booking: require('./pages/crvservice/booking.js').default,

}

window.helpers = {
    validateMail: validateMail,
    resetForm: resetForm
}

if(document.getElementById("reportingTab")) {
    window.confirmation = require('./confirmation').default;
}
if(document.getElementById("admin_service")) {
    window.pages.admin_service = require('./pages/admin/service.js').default;
}



/**
 * enable bootstrap tooltips
 *
 */
$(function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {html: true}))
});










